module.exports = __webpack_public_path__ + "static/media/trash.52a246bc.svg";